import React, { useEffect, useMemo } from "react";
import styles from "../../../../BorrowerDetails.module.css";
import { useBorrowerContext } from "../../../../store/borrower-details";
import { Link as Linkk } from "react-router-dom";
import { BiEdit } from "react-icons/bi";
import { VscNewFolder } from "react-icons/vsc";
import { AiOutlineFolderOpen, AiOutlineDelete } from "react-icons/ai";
import { useState } from "react";
import LoanDocsModal from "../../../Modals/LoanDocsModal";
import { url } from "../../../../../../../App";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import RepaymentsModal from "../../../Modals/RepaymentsModal";
import LoanStatusModal from "../../../Modals/LoanStatusModal";
import LoanMandateModal from "../../../Modals/LoanMandateModal/LoanMandateModal";
import EsignModal from "../../../Modals/EsignModal/EsignModal";
import Cookies from "js-cookie";
import { useParams } from "react-router-dom";
import { FiExternalLink } from "react-icons/fi";
import EditIcon from "@mui/icons-material/Edit";
import ApplicationFormModal from "../../../Modals/EsignModal/ApplicationFormModal";
import KfsModal from "../../../Modals/EsignModal/KfsModal";

const Loan = ({ cpvUpload, openLoader, closeLoader, permissions }) => {
  const { loanid } = useParams();
  const { borrowerData, updateBorrowerData } = useBorrowerContext();
  const fetchedLoanDetails = borrowerData.loan;
  console.log(fetchedLoanDetails, "fetchedLoanDetails");
  const foundLoan = fetchedLoanDetails.find((item) => item.loan_id === loanid);
  const [ip, setIp] = useState("");
  const [esignData, setEsignData] = useState([]);
  const TOKEN = Cookies.get("Token");
  const EMAIL = Cookies.get("Email");
  const [isDisbursed, setIsDisbursed] = useState(false);
  const [documentStatus, setDocumentStatus] = useState({
    loanAgreement: "Not Generated",
    applicationForm: "Not Generated",
    kfsLetter: "Not Generated",
  });
  const [esignModal, setEsignModal] = useState(false);
  const [applicationModal, setApplicationModal] = useState(false);
  const [kfsModal, setKfsModal] = useState(false);

  const fetch = async () => {
    try {
      const { data } = await axios.get("https://api.ipify.org");
      setIp(data);
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    fetch();
  }, []);

  useEffect(() => {
    if (loanid) {
      getEsignDetails();
    }
    //eslint-disable-next-line
  }, [loanid]);

  useEffect(() => {
    const handleUpdateBorrower = async () => {
      try {
        const updateBorrower = await axios.post(
          url + "/borrower/borrowertoalldetails",
          {
            token: TOKEN,
            email: EMAIL,
            borrower_uniqueno: localStorage.getItem("uniqueID"),
          }
        );

        if (updateBorrower.data?.auth) {
          const updatedLoan = updateBorrower.data.message?.loan || [];
          const foundLoanNew = updatedLoan.find((item) => item.loan_id === loanid);

          updateBorrowerData((prevState) => ({
            ...prevState,
            loan: updatedLoan,
          }));
          if (foundLoanNew) {
            const getLatestStatus = (docs = []) => {
              if (!docs?.length) return "Not Generated";

              const docsWithStatus = docs.filter((doc) => doc?.status);
              console.log(docsWithStatus, "docsWithStatus")
              if (!docsWithStatus.length) return "Not Generated";

              return docsWithStatus.sort(
                (a, b) =>
                  new Date(b.timestamp || 0) - new Date(a.timestamp || 0)
              )[0].status;
            };
            console.log(foundLoanNew, "docsWithStatus")

            setDocumentStatus({
              loanAgreement: getLatestStatus(foundLoanNew.loan_agreement),
              applicationForm: getLatestStatus(foundLoanNew.application_form),
              kfsLetter: getLatestStatus(foundLoanNew.kfs_letter),
            });

            if (loanid) {
              setIsDisbursed(foundLoanNew.loan_status === "DISBURSED");
            }
          }
        }
      } catch (error) {
        console.error("Error fetching latest borrower details:", error);
      }
    };

    handleUpdateBorrower();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loanid, TOKEN, EMAIL, esignModal, applicationModal, kfsModal]);

  console.log(foundLoan)
  console.log(documentStatus, "docsWithStatus")

  const getEsignDetails = async () => {
    try {
      openLoader();
      const response = await axios.post(url + "/api/fetch/esign/details", {
        loanId: loanid,
        token: TOKEN,
        email: EMAIL,
      });
      console.log(response.data, "response");

      if (response.data.success) {
        setEsignData(response.data.data);
      } else {
        toast.error(response.data.message || "E-sign details not found");
      }

      closeLoader();
    } catch (err) {
      console.error(err);
      closeLoader();
    }
  };

  const groupedEsignWithStatus = useMemo(() => {
    if (!esignData?.length) return [];

    const map = {};

    esignData.forEach((item) => {
      const id = item.digioid;

      if (!map[id]) {
        map[id] = {
          digioid: id,
          esignInitiatedDate: item.esignInitiatedDate,
          signers: [],
          status: "REQUESTED",
        };
      }

      ["1", "2", "3"].forEach((n) => {
        const name = item[`Signer${n}`];
        if (!name) return;

        map[id].signers.push({
          name,
          mobile: item[`Mobile${n}`],
          status: item[`Signer${n}status`] || "requested",
        });
      });
    });

    Object.values(map).forEach((group) => {
      const statuses = group.signers.map((s) => s.status.toLowerCase());

      const allSigned =
        statuses.length && statuses.every((s) => s === "signed");
      const allExpired =
        statuses.length && statuses.every((s) => s === "expired");
      const anyExpired = statuses.some((s) => s === "expired");

      if (allSigned) {
        group.status = "signed";
      } else if (allExpired || anyExpired) {
        group.status = "expired";
      } else {
        group.status = "requested";
      }
    });

    return Object.values(map);
  }, [esignData]);

  const latestEsign = useMemo(() => {
    if (!groupedEsignWithStatus.length) return null;

    return [...groupedEsignWithStatus].sort(
      (a, b) => new Date(b.esignInitiatedDate) - new Date(a.esignInitiatedDate)
    )[0];
  }, [groupedEsignWithStatus]);
  console.log(latestEsign);

  const [loanDocsExist, setLoanDocsExist] = useState({
    mandateForm: false,
    applicationForm: false,
    sanctionLetter: false,
    auditTrail: false,
    loanAgreement: false,
    kfsLetter: false,
    promissoryNote: false,
    postDateCheck: false,
    miscDoc: false,
    kfsTrailLetter: false,
  });
  const [loanDetails, setLoanDetails] = useState({});
  const [loanDocsModal, setLoanDocsModal] = useState(false);
  const [repaymentModal, setRepaymentModal] = useState(false);
  const [statusModal, setStatusModal] = useState(false);
  const [loanMandateModal, setLoanMandateModal] = useState(false);
  const [statusPermission, setStatusPermission] = useState(true);

  const checkStatusPermissions = async () => {
    const {
      analyst_approve_loan_status,
      analyst_reject_loan_status,
      manager_approved_loan_status,
      manager_rejected_loan_status,
      nbfc_approved_loan_status,
      nbfc_rejected_loan_status,
      esign_initiated_loan_status,
      esigned_loan_status,
      enach_initiated_loan_status,
      enach_done_loan_status,
      rfd_loan_status,
      cancelled_loan_status,
      closed_status,
      restructured_loan_status,
      foreclosed_loan_status,
      settled_loan_status,
      disbursed_loan_status,
      cpv_initiated_loan_status,
      cpv_done_loan_status,
      topup_loan_status,
      drop_off_loan_status,
      query_raised_loan_status,
      query_resolved_loan_status,
      created_loan_status,
    } = permissions;

    const permissionCheck = Object.values({
      analyst_approve_loan_status,
      analyst_reject_loan_status,
      manager_approved_loan_status,
      manager_rejected_loan_status,
      nbfc_approved_loan_status,
      nbfc_rejected_loan_status,
      esign_initiated_loan_status,
      esigned_loan_status,
      enach_initiated_loan_status,
      enach_done_loan_status,
      rfd_loan_status,
      cancelled_loan_status,
      closed_status,
      restructured_loan_status,
      foreclosed_loan_status,
      settled_loan_status,
      disbursed_loan_status,
      cpv_initiated_loan_status,
      cpv_done_loan_status,
      topup_loan_status,
      drop_off_loan_status,
      query_raised_loan_status,
      query_resolved_loan_status,
      created_loan_status,
    }).some((permission) => permission);
    setStatusPermission(permissionCheck);
    console.log(statusPermission);
  };

  const {
    edit_loan,
    view_loan_document,
    loan_terms_loan_details,
    delete_loan,
    status_access,
    download_loan_document,
    add_loan_document,
    loan_schedule_loan_details,
    foreclosure_details_loan_details,
    charges_loan_details,
    repayments_loan_details,
    generate_kfs_letter,
    initiate_kfs_letter,
    upload_kfs_letter,
    view_kfs_letter,
    download_kfs_letter,
    signed_kfs_letter,
    generate_application_form_doc,
    initiate_application_form_doc,
    upload_application_form_doc,
    view_application_form_doc,
    download_application_form_doc,
    signed_application_form_doc,
    generate_loan_agreement,
    initiate_loan_agreement,
    upload_loan_agreement,
    view_loan_agreement,
    download_loan_agreement,
    Initiate_enach_loan,
  } = permissions;

  useEffect(() => {
    checkStatusPermissions();
    //eslint-disable-next-line
  }, [permissions]);

  const loanDocsModalHandler = async (data) => {
    openLoader();
    setLoanDocsExist({
      mandateForm: false,
      applicationForm: false,
      sanctionLetter: false,
      auditTrail: false,
      loanAgreement: false,
      kfsLetter: false,
      miscDoc: false,
    });
    console.log(data);
    setLoanDetails(data);
    setLoanDocsModal(true);

    if (!!data.mandate_form === true) {
      setLoanDocsExist((prevState) => ({
        ...prevState,
        mandateForm: true,
      }));
    }
    if (!!data.application_form === true) {
      setLoanDocsExist((prevState) => ({
        ...prevState,
        applicationForm: true,
      }));
    }
    if (!!data.saction_letter === true) {
      setLoanDocsExist((prevState) => ({
        ...prevState,
        sanctionLetter: true,
      }));
    }
    if (!!data.loan_agreement === true) {
      setLoanDocsExist((prevState) => ({
        ...prevState,
        loanAgreement: true,
      }));
    }
    if (data.audit_trail) {
      setLoanDocsExist((prevState) => ({
        ...prevState,
        auditTrail: true,
      }));
    }
    if (data.loan_mis_doc) {
      setLoanDocsExist((prevState) => ({
        ...prevState,
        miscDoc: true,
      }));
    }
    if (data.kfs_letter) {
      setLoanDocsExist((prevState) => ({
        ...prevState,
        kfsLetter: true,
      }));
    }
    if (data.demand_promissory_note) {
      setLoanDocsExist((prevState) => ({
        ...prevState,
        promissoryNote: true,
      }));
    }
    if (data.post_date_check) {
      setLoanDocsExist((prevState) => ({
        ...prevState,
        postDateCheck: true,
      }));
    }
    if (data.kfs_audit_trail) {
      setLoanDocsExist((prevState) => ({
        ...prevState,
        kfsTrailLetter: true,
      }));
    }
    closeLoader();
    return;
  };

  const deleteLoanHandler = (loan_id) => {
    let text = "Are you sure you want to delete Loan " + loan_id + "?";
    if (window.confirm(text) === true) {
      openLoader();
      axios
        .post(url + "/loan/delete", {
          token: Cookies.get("Token"),
          ip: ip,
          hostname: window.location.hostname,
          email: Cookies.get("Email"),
          loan_id: loan_id,
        })
        .then((res) => {
          toast.success(res.data.message);
          axios
            .post(url + "/borrower/borrowertoalldetails", {
              token: Cookies.get("Token"),
              email: Cookies.get("Email"),
              borrower_uniqueno: localStorage.getItem("uniqueID"),
            })
            .then((res) => {
              if (res.data.auth === false) {
                closeLoader();
                toast.error(res.data.message);
              } else {
                updateBorrowerData((prevState) => ({
                  ...prevState,
                  loan: res.data.message.loan,
                }));
                closeLoader();
              }
            })
            .catch((err) => {
              console.log(err);
              toast.error(err.message);
              closeLoader();
              return;
            });
        })
        .catch((err) => {
          console.log(err);
          closeLoader();
          return;
        });
    }
  };

  const repaymentModalHandler = (data) => {
    setRepaymentModal(true);
    setLoanDetails(data);
  };

  const statusModalHandler = (data) => {
    console.log(data);
    setLoanDetails(data);
    setStatusModal(true);
  };

  const closeStatusModal = () => {
    setStatusModal(false);
    setLoanDetails({});
  };

  const closeLoanDocsModal = () => {
    setLoanDocsModal(false);
    setLoanDetails({});
  };

  const closeRepaymentModal = () => {
    setRepaymentModal(false);
    setLoanDetails({});
  };

  const openLoanMandateModal = (data) => {
    setLoanMandateModal(true);
    setLoanDetails({ data });
  };

  const closeLoanMandateModal = () => {
    setLoanMandateModal(false);
    setLoanDetails({});
  };

  const esignModalHandler = (loan) => {
    setEsignModal(true);
    setLoanDetails(loan);
    if (!!loan.loan_agreement === true) {
      setLoanDocsExist((prevState) => ({
        ...prevState,
        loanAgreement: true,
      }));
    }
  };

  const closeEsignModalHandler = () => {
    setEsignModal(false);
    setLoanDetails({});
  };

  const applicationModalHandler = (loan) => {
    setApplicationModal(true);
    setLoanDetails(loan);
    if (!!loan.application_form === true) {
      setLoanDocsExist((prevState) => ({
        ...prevState,
        applicationForm: true,
      }));
    }
  };

  const closeApplicationModalHandler = () => {
    setApplicationModal(false);
    setLoanDetails({});
  };

  const kfsModalHandler = (loan) => {
    setKfsModal(true);
    setLoanDetails(loan);
    if (!!loan.kfs_letter === true) {
      setLoanDocsExist((prevState) => ({
        ...prevState,
        kfsLetter: true,
      }));
    }
  };

  const closeKfsModalHandler = () => {
    setKfsModal(false);
    setLoanDetails({});
  };

  const REQUIRED_STATUSES = [
    "ANALYST APPROVED",
    "MANAGER APPROVED",
    "LENDER APPROVED",
    "ESIGNED",
    "RFD",
    "DISBURSED",
  ];
  const REJECTED_STATUSES = [
    "ANALYST REJECTED",
    "MANAGER REJECTED",
    "LENDER REJECTED",
  ];
  const OTHER_REJECT_STATUSES = ["DROP OFF", "CANCELLED"];

  const StepProgressBar = ({ loanStatusTrail }) => {
    const completedStatuses = loanStatusTrail.map((item) => item.loan_status);
    const latestStatus = completedStatuses[completedStatuses.length - 1];

    const maxStepIndex = REQUIRED_STATUSES.reduce(
      (acc, status, index) =>
        completedStatuses.includes(status) ? index : acc,
      -1
    );
    console.log(maxStepIndex);

    const [animatedStep, setAnimatedStep] = useState(0);

    useEffect(() => {
      if (animatedStep < maxStepIndex + 1) {
        const timeout = setTimeout(() => {
          setAnimatedStep((prev) => prev + 1);
        }, 500);
        return () => clearTimeout(timeout);
      }
    }, [animatedStep, maxStepIndex]);

    return (
      <div
        style={{
          display: "flex",
          alignItems: "center",
          margin: "5px 0",
          paddingLeft: "10px",
          paddingRight: "10px",
        }}
      >
        {REQUIRED_STATUSES.map((status, index) => {
          const isCompleted = index < animatedStep;
          const isCurrentNext = index === animatedStep;
          const isLast = index === REQUIRED_STATUSES.length - 1;
          console.log(latestStatus);

          const correspondingRejection = REJECTED_STATUSES.find((r) =>
            r.includes(status?.split(" ")[0])
          );
          const isRejected =
            correspondingRejection &&
            completedStatuses.includes(correspondingRejection);
          const isHardRejected =
            OTHER_REJECT_STATUSES.includes(latestStatus) &&
            status === REQUIRED_STATUSES[animatedStep];

          let displayContent = "";
          let backgroundColor = "#ccc";
          let color = "black";
          let tooltip = status;

          if ((isRejected && correspondingRejection) || isHardRejected) {
            displayContent = "✕";
            backgroundColor = "#f44336";
            color = "white";
            tooltip = isHardRejected ? latestStatus : correspondingRejection;
          } else if (isCompleted) {
            displayContent = "✓";
            backgroundColor = "#4caf50";
            color = "white";
          } else if (
            isCurrentNext &&
            !completedStatuses.includes(status) &&
            !REQUIRED_STATUSES.includes(latestStatus)
          ) {
            displayContent = ":::";
            tooltip = `${latestStatus}`;
            backgroundColor = "#f0ad4e";
            color = "white";
          } else {
            displayContent = "";
          }

          const percentComplete = 50 + index * 10;

          return (
            <React.Fragment key={status}>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  position: "relative",
                }}
              >
                <div
                  title={tooltip}
                  style={{
                    backgroundColor,
                    color,
                    borderRadius: "50%",
                    width: 18,
                    height: 18,
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    fontWeight: "bold",
                    fontSize: "10px",
                    cursor: "default",
                    transition: "all 0.3s ease",
                  }}
                >
                  {displayContent}
                </div>

                {isCompleted && animatedStep - 1 === index && (
                  <div
                    style={{
                      position: "absolute",
                      top: 22,
                      left: "50%",
                      transform: "translateX(-50%)",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      fontSize: "10px",
                      color: "#555",
                      whiteSpace: "nowrap",
                    }}
                  >
                    {percentComplete}%
                    {percentComplete === 100 && (
                      <span style={{ marginLeft: 4 }}>✨</span>
                    )}
                  </div>
                )}
              </div>

              {!isLast && (
                <div
                  style={{
                    flex: 1,
                    height: 5,
                    backgroundColor: animatedStep > index ? "#4caf50" : "#ccc",
                    transition: "background-color 0.3s ease",
                  }}
                />
              )}
            </React.Fragment>
          );
        })}
      </div>
    );
  };

  const badgeStyle = {
    active: {
      backgroundColor: "#e6ffe6", // Light green
      color: "#00cc00", // Green text
      padding: "2px 4px",
      borderRadius: "12px",
      fontSize: "12px",
      fontWeight: "bold",
    },
    inActive: {
      backgroundColor: "#ffe6e6", // Light red background
      color: "#d32f2f", // Proper red text
      padding: "2px 4px",
      borderRadius: "12px",
      fontSize: "12px",
      fontWeight: "bold",
    },
    signed: {
      backgroundColor: "#e6ffe6", // Light green
      color: "#00cc00", // Green text
      padding: "2px 8px",
      borderRadius: "10px",
      fontSize: "14px",
      fontWeight: "bold",
    },
    linkIcon: {
      color: "#868686", // Grey icon color
      fontSize: "14px",
      cursor: "pointer",
      marginLeft: "-3px",
      marginRight: "5px",
    },
  };

  return (
    <>
      <ToastContainer />
      {esignModal && (
        <div className={styles.esignModal}>
          <div
            className={styles.esignModaOverlay}
            onClick={(e) =>
              e.target === e.currentTarget && closeEsignModalHandler()
            }
          >
            <div className={styles.esignModalContent}>
              <EsignModal
                closeModal={closeEsignModalHandler}
                loanDetails={loanDetails}
                openLoader={openLoader}
                closeLoader={closeLoader}
                loanDocsExist={loanDocsExist}
                permissions={permissions}
                isDisbursed={isDisbursed}
              />
            </div>
          </div>
        </div>
      )}
      {applicationModal && (
        <div className={styles.esignModal}>
          <div
            className={styles.esignModaOverlay}
            onClick={(e) =>
              e.target === e.currentTarget && closeApplicationModalHandler()
            }
          >
            <div className={styles.esignModalContent}>
              <ApplicationFormModal
                closeModal={closeApplicationModalHandler}
                loanDetails={loanDetails}
                openLoader={openLoader}
                closeLoader={closeLoader}
                loanDocsExist={loanDocsExist}
                permissions={permissions}
                isDisbursed={isDisbursed}
              />
            </div>
          </div>
        </div>
      )}
      {kfsModal && (
        <div className={styles.esignModal}>
          <div
            className={styles.esignModaOverlay}
            onClick={(e) =>
              e.target === e.currentTarget && closeKfsModalHandler()
            }
          >
            <div className={styles.esignModalContent}>
              <KfsModal
                closeModal={closeKfsModalHandler}
                loanDetails={loanDetails}
                openLoader={openLoader}
                closeLoader={closeLoader}
                loanDocsExist={loanDocsExist}
                permissions={permissions}
                isDisbursed={isDisbursed}
              />
            </div>
          </div>
        </div>
      )}

      {loanDocsModal && (
        <LoanDocsModal
          loanDocsExist={loanDocsExist}
          loanID={loanDetails}
          closeModal={closeLoanDocsModal}
          loanDocsFx={loanDocsModalHandler}
          openLoader={openLoader}
          permissions={permissions}
          closeLoader={closeLoader}
          isDisbursed={isDisbursed}
        />
      )}
      {repaymentModal && (
        <RepaymentsModal
          closeModal={closeRepaymentModal}
          loanData={loanDetails}
          openLoader={openLoader}
          closeLoader={closeLoader}
        />
      )}
      {statusModal && (
        <LoanStatusModal
          closeModal={closeStatusModal}
          loanDetails={loanDetails}
          cpvUpload={cpvUpload}
          openLoader={openLoader}
          closeLoader={closeLoader}
        />
      )}
      {loanMandateModal && (
        <div className={styles.loanMandateModal}>
          <div
            className={styles.loanMandateModaOverlay}
            onClick={(e) =>
              e.target === e.currentTarget && closeLoanMandateModal()
            }
          >
            <div className={styles.loanMandateModalContent}>
              <LoanMandateModal
                closeModal={closeLoanMandateModal}
                loanDetails={loanDetails}
                openLoader={openLoader}
                closeLoader={closeLoader}
                isDisbursed={isDisbursed}
              />
            </div>
          </div>
        </div>
      )}

      <div className={styles.loanList}>
        {fetchedLoanDetails
          ?.filter((loan) => loan.loan_id === loanid)
          .map((data) => {
            const mandates = data?.loan_mandate || [];

            const SUCCESS_BANK_STATUSES = [
              "auth_success",
              "successful",
              "transfer_success",
              "accepted_spo_bank",
              "ack_received",
              "register_success",
            ];

            const isActive = mandates?.some((m) => {
              const isBankActive = SUCCESS_BANK_STATUSES.includes(
                m?.bank_status?.trim().toLowerCase()
              );

              const isLmsActive = m?.lms_Mandate_Status?.trim().toLowerCase() === "activate";

              return isBankActive && isLmsActive;
            });

            const isInactive = !isActive;

            const formattedDate = data?.loan_release_date
              ? new Date(data?.loan_release_date).toLocaleDateString("en-GB")
              : null;

            return (
              <div key={data._id} className={styles.loanBorrowerDetails}>
                <div className={styles.personalLoan}>
                  <div className={styles.personalLoanContainer}>
                    <div
                      className={styles.loanName}
                      style={{
                        display: "flex",
                        alignItems: "center",
                        flexWrap: "wrap",
                        gap: "1rem",
                      }}
                    >
                      <div>
                        <span className={styles.personalLoanText}>
                          {data.loanproduct_name}
                        </span>
                      </div>

                      <div></div>
                    </div>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "flex-end",
                        alignItems: "center",
                      }}
                    >
                      <div
                        style={{
                          alignSelf: "flex-start",
                          marginRight: "auto",
                          fontSize: "0.9rem",
                          color: "#034ea1",
                          marginLeft: "1rem",
                          marginTop: ".4vh",
                        }}
                      >
                        <span
                          style={{
                            fontWeight: "600",
                            marginLeft: "-0.8vw",
                          }}
                        >
                          NBFC
                        </span>
                        : {data.nbfc_name}
                      </div>
                      <div>
                        {edit_loan && (
                          <Linkk to="/loan/edit" state={data}>
                            <BiEdit
                              color="green"
                              title="Edit"
                              cursor="pointer"
                              size={18}
                            />
                          </Linkk>
                        )}
                      </div>

                      {view_loan_document ||
                      download_loan_document ||
                      add_loan_document ? (
                        <div>
                          <VscNewFolder
                            onClick={() => loanDocsModalHandler(data)}
                            color="#FF5500"
                            title="View Documents"
                            cursor="pointer"
                            style={{
                              marginLeft: "1rem",
                            }}
                            size={18}
                          />
                        </div>
                      ) : (
                        ""
                      )}
                      {loan_terms_loan_details ||
                      add_loan_document ||
                      view_loan_document ||
                      download_loan_document ||
                      foreclosure_details_loan_details ||
                      charges_loan_details ||
                      loan_schedule_loan_details ? (
                        <Linkk to="/viewloandetails" state={data}>
                          <AiOutlineFolderOpen
                            color="#034ea1"
                            title="View Loan Details"
                            cursor="pointer"
                            style={{
                              marginLeft: "1rem",
                            }}
                            size={18}
                          />
                        </Linkk>
                      ) : (
                        ""
                      )}
                      {delete_loan && !isDisbursed && (
                        <AiOutlineDelete
                          color="red"
                          cursor="pointer"
                          title="Delete"
                          style={{ marginLeft: ".7rem" }}
                          size={18}
                          onClick={() => deleteLoanHandler(data.loan_id)}
                        />
                      )}
                    </div>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "0.75rem",
                        flexWrap: "nowrap",
                      }}
                    >
                      <span style={{ fontSize: "0.9rem", color: "#034ea1" }}>
                        <b>Status :</b> {data.loan_status}
                      </span>
                      {status_access && (
                        <span title="Edit Status">
                          <EditIcon
                            cursor="pointer"
                            size={18}
                            style={{ color: "green" }}
                            onClick={() => statusModalHandler(data)}
                          />
                        </span>
                      )}
                      <span
                        style={{
                          fontSize: "0.9rem",
                          color: "#034ea1",
                          marginLeft: "1rem",
                        }}
                      >
                        <b>Loan ID :</b> {data.loan_id}
                      </span>
                    </div>
                    <hr
                      style={{
                        backgroundColor: "gray",
                        width: "100%",
                        margin: ".2rem 0",
                      }}
                    />
                    <table width="100%" className={styles.myClass}>
                      <thead>
                        <tr>
                          <th>Loan Amount</th>
                          <th>Interest Rate</th>
                          <th>Tenure</th>
                          <th>Loan Release Date</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>{data.loan_principal_amt}/-</td>
                          <td>{data.loanproduct_interest_rate}%</td>
                          <td
                            className={`${
                              repayments_loan_details ? styles.tenure : ""
                            }`}
                            onClick={() => {
                              if (repayments_loan_details) {
                                repaymentModalHandler(data);
                              }
                            }}
                          >
                            {data.loan_duration} Months
                          </td>
                          <td>{formattedDate ?? "-"}</td>
                        </tr>
                      </tbody>
                    </table>
                    <div>
                      {data.loan_status_trail && (
                        <StepProgressBar
                          loanStatusTrail={data?.loan_status_trail}
                        />
                      )}
                    </div>
                  </div>
                </div>
                <div
                  style={{
                    display: "flex",
                    gap: ".5rem",
                    alignItems: "center",
                  }}
                >
                  {(generate_application_form_doc ||
                    view_application_form_doc ||
                    initiate_application_form_doc ||
                    download_application_form_doc ||
                    upload_application_form_doc ||
                    signed_application_form_doc) && (
                    <>
                      <div style={{ fontWeight: "bold", fontSize: "12px" }}>
                        APPLICATION FORM:
                      </div>

                      <div
                        style={
                          documentStatus.applicationForm?.toLowerCase() ===
                          "signed"
                            ? badgeStyle.active
                            : documentStatus.applicationForm?.toLowerCase() ===
                              "partially signed"
                            ? badgeStyle.active
                            : documentStatus.applicationForm?.toLowerCase() ===
                              "generated"
                            ? badgeStyle.active
                            : documentStatus.applicationForm?.toLowerCase() ===
                              "expired"
                            ? badgeStyle.inActive
                            : documentStatus.applicationForm?.toLowerCase() ===
                              "not generated"
                            ? badgeStyle.inActive
                            : badgeStyle.active
                        }
                      >
                        {documentStatus.applicationForm
                          ?.split(" ")
                          .map(
                            (word) =>
                              word.charAt(0).toUpperCase() +
                              word.slice(1).toLowerCase()
                          )
                          .join(" ")}
                      </div>

                      <div onClick={() => applicationModalHandler(data)}>
                        <FiExternalLink
                          title="Application Form Details"
                          style={badgeStyle.linkIcon}
                        />
                      </div>
                    </>
                  )}

                  {(generate_kfs_letter ||
                    view_kfs_letter ||
                    initiate_kfs_letter ||
                    download_kfs_letter ||
                    upload_kfs_letter ||
                    signed_kfs_letter) && (
                    <>
                      <div style={{ fontWeight: "bold", fontSize: "12px" }}>
                        KFS/SANCTION LETTER:
                      </div>

                      <div
                        style={
                          documentStatus.kfsLetter?.toLowerCase() === "signed"
                            ? badgeStyle.active
                            : documentStatus.kfsLetter?.toLowerCase() ===
                              "partially signed"
                            ? badgeStyle.active
                            : documentStatus.kfsLetter?.toLowerCase() ===
                              "generated"
                            ? badgeStyle.active
                            : documentStatus.kfsLetter?.toLowerCase() ===
                              "expired"
                            ? badgeStyle.inActive
                            : documentStatus.kfsLetter?.toLowerCase() ===
                              "not generated"
                            ? badgeStyle.inActive
                            : badgeStyle.active
                        }
                      >
                        {documentStatus.kfsLetter
                          ?.split(" ")
                          .map(
                            (word) =>
                              word.charAt(0).toUpperCase() +
                              word.slice(1).toLowerCase()
                          )
                          .join(" ")}
                      </div>

                      <div onClick={() => kfsModalHandler(data)}>
                        <FiExternalLink
                          title="Kfs/Sanction letter Details"
                          style={badgeStyle.linkIcon}
                        />
                      </div>
                    </>
                  )}

                  {(generate_loan_agreement ||
                    view_loan_agreement ||
                    initiate_loan_agreement ||
                    download_loan_agreement ||
                    upload_loan_agreement) && (
                    <>
                      <div style={{ fontWeight: "bold", fontSize: "12px" }}>
                        Agreement:
                      </div>

                      <div
                        style={
                          documentStatus.loanAgreement?.toLowerCase() ===
                          "signed"
                            ? badgeStyle.active
                            : documentStatus.loanAgreement?.toLowerCase() ===
                              "partially signed"
                            ? badgeStyle.active
                            : documentStatus.loanAgreement?.toLowerCase() ===
                              "generated"
                            ? badgeStyle.active
                            : documentStatus.loanAgreement?.toLowerCase() ===
                              "expired"
                            ? badgeStyle.inActive
                            : documentStatus.loanAgreement?.toLowerCase() ===
                              "not generated"
                            ? badgeStyle.inActive
                            : badgeStyle.active
                        }
                      >
                        {documentStatus.loanAgreement
                          ?.split(" ")
                          .map(
                            (word) =>
                              word.charAt(0).toUpperCase() +
                              word.slice(1).toLowerCase()
                          )
                          .join(" ")}
                      </div>

                      <div onClick={() => esignModalHandler(data)}>
                        <FiExternalLink
                          title="Esign Details"
                          style={badgeStyle.linkIcon}
                        />
                      </div>
                    </>
                  )}

                  {Initiate_enach_loan && (
                    <>
                      <div style={{ fontWeight: "bold", fontSize: "12px" }}>
                        NACH:
                      </div>
                      <div
                        style={
                          mandates.length === 0
                            ? badgeStyle.inActive
                            : isInactive
                              ? badgeStyle.inActive
                              : badgeStyle.active
                        }
                      >
                        {mandates.length > 0
                          ? isInactive
                            ? "Inactive"
                            : "Active"
                          : "Not Initiated"}
                      </div>

                      <div onClick={() => openLoanMandateModal(data)}>
                        <FiExternalLink
                          title="Loan Mandate Details"
                          style={badgeStyle.linkIcon}
                        />
                      </div>
                    </>
                  )}

                  {/* <div style={{ fontWeight: "bold", fontSize: "12px" }}>
                    Agreement:
                  </div>

                  <div
                    style={
                      !latestEsign
                        ? badgeStyle.active
                        : latestEsign.status === "signed"
                        ? badgeStyle.active
                        : latestEsign.status === "expired"
                        ? badgeStyle.active
                        : badgeStyle.active
                    }
                  >
                    {!latestEsign
                      ? "Not Found"
                      : latestEsign.status === "signed"
                      ? "Signed"
                      : latestEsign.status === "expired"
                      ? "Expired"
                      : "Requested"}
                  </div>

                  <div onClick={() => esignModalHandler(data)}>
                    <FiExternalLink
                      title="Esign Details"
                      style={badgeStyle.linkIcon}
                    />
                  </div> */}
                </div>
              </div>
            );
          })}
      </div>
    </>
  );
};

export default Loan;
